<template>
  <div v-b-tooltip.hover :title="tooltip[hook]">
    {{ label[hook] }}
    <b-form-input v-model="innerValue.args.name" 
      placeholder="(バフ名称)"
      class="action" />
    <b-input-group append="T" class="length">
      <b-form-input v-model="innerValue.args.length" 
        type="number" min="1" max="30" number />
    </b-input-group>
    <b-form-select v-model="innerValue.args.color" 
      :options="[
        { value:'a', text:'灰' },
        { value:'r', text:'赤' },
        { value:'b', text:'青' },
        { value:'y', text:'黄' },
        { value:'s', text:'茶' },
        { value:'g', text:'緑' },
        { value:'w', text:'白' },
        { value:'d', text:'黒' },
        { value:'n', text:'無' }
      ]"
      class="buff" />
    <b-form-select v-model="innerValue.args.type" 
      :options="[
        { value:'buff-magic', text:'強化魔法' },
        { value:'debuff-magic', text:'弱体魔法' },
        { value:'buff-stance', text:'強化体勢' },
        { value:'debuff-stance', text:'弱体体勢' },
        { value:'buff-physical', text:'強化肉体' },
        { value:'debuff-physical', text:'弱体肉体' },
        { value:'buff-mental', text:'強化精神' },
        { value:'debuff-mental', text:'弱体精神' },
        { value:'debuff-cooltime', text:'CT' },
      ]" 
      class="buff" />
    <b-form-select v-model="innerValue.args.mode" 
      :options="[
        { value:'add', text:'追加' },
        { value:'overwrite', text:'上書き' },
        { value:'merge', text:'合成' },
        { value:'extension', text:'延長' },
      ]" 
      class="buff" />
  </div>
</template>

<script>
import Hook from './Hook'
export default {
  extends: Hook
}
</script>

<style lang="scss" scoped>
.action {
  display: inline-block;
  width: 200px;
}
.length {
  display: inline-flex;
  width: 100px;
}
.buff {
  display: inline-block;
  width: 75px;
}
</style>